import { Box, Typography } from "@mui/material";
import Image from "next/image";
import { makeStyles } from "tss-react/mui";
import { pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";
type props = {
  reverse: boolean;
  image: string;
  description: string;
  title: string;
};
const ServiceCard = ({ title, description, image, reverse }: props) => {
  const { classes } = styles({ reverse });

  return (
    <Box className={classes.container}>
      <Box className={classes.imageContainer}>
        <Image
          src={image}
          alt={title}
          layout="responsive"
          width={800}
          height={400}
          objectFit="cover"
        />
      </Box>
      <Box className={classes.display}>
        <Typography className={classes.heading}>{title}</Typography>
        <Typography className={classes.description}>{description}</Typography>
      </Box>
    </Box>
  );
};

export default ServiceCard;

const styles = makeStyles<{ reverse: boolean }>()((theme, { reverse }) => ({
  container: {
    display: "flex",
    flexDirection: reverse ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "space-around",
    gap: theme.spacing(4),
    border: `1px solid ${theme.colors.gray}`,
    borderRadius: pxToRem(8),
    padding: theme.spacing(4),

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      textAlign: "center",
      boxShadow: "0px 4px 6px -1px #1018281A, 0px 2px 4px -2px #1018281A",
    },
  },
  display: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    flex: 1,
    alignItems: "flex-start",

    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  imageContainer: {
    flex: 1,
    width: "100%",
    borderRadius: pxToRem(20),
    overflow: "hidden",

    [theme.breakpoints.down("sm")]: {
      width: "110%",
      height: pxToRem(250),
    },
  },

  heading: {
    fontFamily: "Playfair Display",
    fontSize: pxToRem(30),
    fontWeight: "700",
    textTransform: "capitalize",
    lineHeight: "120%",
    color: AppColors.text.default,

    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(24),
      textAlign: "left",
    },
  },
  description: {
    fontFamily: "General Sans",
    fontSize: pxToRem(16),
    color: AppColors.text.second,
    fontWeight: 300,
    lineHeight: "160%",
    textAlign: "justify",

    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(17),
      width: "100%",
      lineHeight: "160%",
      textAlign: "left",
    },
  },
}));
